import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { OfferSection } from './components/OfferSection';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  (function (f: any, b: any, e: any, v: any) {
    var n: any, t: any, s: any;
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      b.head.appendChild(t);
    }
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', '3895908973971716');
  window.fbq('track', 'PageView');
  // Add noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=3895908973971716&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-background text-white font-sans relative" data-id="element-0">
      <div className="fixed inset-0 bg-noise z-50 pointer-events-none mix-blend-overlay" data-id="element-1"></div>
      <main className="relative z-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <OfferSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <ClosingSection data-id="element-8" />
      </main>
    </div>;
}